<template>
    <div class="contract-create">
        <pay-box title="新增模板合同">
            <div class="form-box">
                <div class="row">
                    <div class="label">公司身份</div>
                    <div class="content">
                        <div class="input-container">
                            <a-radio-group name="radioGroup" v-model="radio" size="large">
                                <a-radio :value="1">甲方</a-radio>
                                <a-radio :value="2">乙方</a-radio>
                            </a-radio-group>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="label label-required">协议标题</div>
                    <div class="content">
                        <div class="input-container">
                            <a-input v-model="title" placeholder="请输入不超过50字的协议标题" size="large" style="border-radius: 0;" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="label">协议示范</div>
                    <div class="content">
                        <div class="demo-container">
                            <template v-if="radio == 1">
                                <div class="text">
                                    <div>甲方：{{ info.enterprise_name }}</div>
                                    <div>联系人：{{ info.legal_representative_name }}</div>
                                    <div>联系方式：{{ info.enterprise_phone }}</div>
                                    <div>联系地址：{{ info.enterprise_address }}</div>
                                    <div style="margin-top: 40px;">乙方：/</div>
                                    <div>身份证号：/</div>
                                    <div style="margin: 0;">联系方式：/</div>
                                </div>
                                <div class="tips">
                                    <img src="/assets/images/contract-icon-tips.png">
                                    <span>抬头由系统自动生成</span>
                                </div>
                            </template>

                            <template v-if="radio == 2">
                                <div class="text">
                                    <div>甲方：/</div>
                                    <div>身份证号：/</div>
                                    <div>联系方式：/</div>
                                    <div style="margin-top: 40px;">乙方：{{ info.enterprise_name }}</div>
                                    <div>联系人：{{ info.legal_representative_name }}</div>
                                    <div>联系方式：{{ info.enterprise_phone }}</div>
                                    <div style="margin: 0;">联系地址：{{ info.enterprise_address }}</div>
                                </div>
                                <div class="tips">
                                    <img src="/assets/images/contract-icon-tips.png">
                                    <span>抬头由系统自动生成</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="label">协议内容</div>
                    <div class="content">
                        <quill-editor v-model="content" ref="myQuillEditor" :options="editorOption" class="editor"></quill-editor>
                    </div>
                </div>
                <div class="row">
                    <div class="label">内容示范</div>
                    <div class="content">
                        <div class="demo-container">
                            <div class="text-row">
                                <template v-if="radio == 1">
                                    <div class="left">
                                        <div>甲方：{{ info.enterprise_name }}</div>
                                        <div style="margin: 20px 0;">盖章：</div>
                                        <div>时间：</div>
                                    </div>
                                    <div class="right">
                                        <div>乙方：张三（示例）</div>
                                        <div style="margin: 20px 0;">签名：</div>
                                        <div>时间：</div>
                                    </div>
                                </template>
                                <template v-if="radio == 2">
                                    <div class="left">
                                        <div>甲方：张三（示例）</div>
                                        <div style="margin: 20px 0;">签名：</div>
                                        <div>时间：</div>
                                    </div>
                                    <div class="right">
                                        <div>乙方：{{ info.enterprise_name }}</div>
                                        <div style="margin: 20px 0;">盖章：</div>
                                        <div>时间：</div>
                                    </div>
                                </template>
                            </div>
                            <div class="signed"></div>
                            <div class="tips">
                                <img src="/assets/images/contract-icon-tips.png">
                                <span>抬头由系统自动生成</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </pay-box>

        <div class="btn-box" style="margin-bottom: 100px;">
            <button class="btn" @click="save">保存</button>
            <button class="btn cancel" @click="cancel">取消</button>
        </div>
    </div>
</template>

<script>
import api from '@/repo/api';
import PayBox from "@/views/AST/Pay/Step/PayBox";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
    name: "ContractUpdate",
    components: {
        PayBox,quillEditor
    },
    props: {
        id: {
            default:0
        },
        info: {
            default:() => {}	
        }
    },
    data() {
        return {
            radio: 1,
            title: "",
            content: "",
			editorOption: {
				theme: "snow",
                placeholder: "请输入协议内容",
				modules: {
					toolbar: [
						[
                            { header: [1, 2, 3, 4, 5, 6, false] },
                            "bold", "italic", "underline", "strike",
                            // { color: [] }, { background: [] },
                            "blockquote",{ list: "ordered" }, { list: "bullet" },{ align: [] }
                        ],
					],
				},
			},
        }
    },
    mounted() {
        if (this.id) {
            this.getInfo();
        }	
    },
    methods: {
        // 取消
        cancel(){
            this.$emit('cancel');
        },
        // 保存
        save(){
            if (!this.title) {
                return this.$message.error('协议标题不能为空');
            }
            if (!this.content) {
                return this.$message.error('协议内容不能为空');
            }
            
            let params = {
                title: this.title,
                content: this.content,
                sign_type: this.radio == 1 ? '甲方' : '乙方',
            }
            
            if (this.id) {
                params.id = this.id;	
            }
            this.$loading.show();
            api.post('/ast-contract/sync-contract',params, (res) => {
                if (res.code === 0) {
                    this.$emit('save');
                } else {
                    this.$message.error(res.msg);
                }
                this.$loading.hide();
            });
        },
        // 切换
        radioChange(e){
            this.radio = e.target.value;
        },
        // 获取协议信息
        getInfo(){
            api.get('/ast-contract/contract-detail',{id:this.id}, (res) => {
                if (res.code === 0) {
                    this.title = res.data.title;
                    this.content = res.data.content;
                    this.radio = res.data.sign_type == '甲方'?1:2;
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
    .cancel{
        width: 80px;
        height: 32px;
        border: 1px solid #333333;
        background: #fff;
        color: #333333;
        margin-left: 20px;
    }
    .form-box{
        width: 100%;
        .row{
           display: flex;
           margin-bottom: 24px;
           .label{
              color: #333333;
              font-size: 14px;
              line-height: 40px;
           }
           .label-required{
                position: relative;
                &::after{
                    content: '*';
                    position: absolute;
                    top: 0;
                    left: -8px;
                    color: red;
                    display: block;
                }
           }
           .content{
                flex: 1;
                margin-left: 16px;
                .input-container{
                    width: 100%;
                    min-height: 40px;
                    display: flex;
                    align-items: center;
                }
                .demo-container{
                    width: 100%;
                    background: #FAFAFA;
                    padding: 16px;
                    box-sizing: border-box;
                    position: relative;
                    .tips{
                        height: 32px;
                        background: #FEFBE6;
                        border-radius: 2px;
                        border: 1px solid #F2E3B1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 0 8px;
                        position: absolute;
                        right: 16px;
                        bottom: 16px;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 8px;
                        }
                        span{
                            color: #606266;
                            font-size: 14px;
                            line-height: 32px;
                        }
                    }
                    .text{
                        color: #999999;
                        font-size: 14px;
                        line-height: 20px;
                        div{
                            margin-bottom: 12px;
                        }
                    }
                    .text-row{
                        width: 100%;
                        padding-right: 140px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .left,.right{
                            height: 52px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            color: #999999;
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                    .signed{
                        width: 100%;
                        height: 88px;
                    }
                }
                .editor{
                    width: 100%;
                    height: 300px;
                    margin-bottom: 40px;
               }
           }
        }
    }
</style>